import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

const AboutPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="relative bg-surface-950 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-mesh opacity-20" />
        <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-accent-600/15 rounded-full blur-[120px] animate-float" />
        <div className="absolute bottom-1/4 right-1/3 w-64 h-64 bg-pink-600/15 rounded-full blur-[100px] animate-float-delayed" />

        <div className="relative max-w-4xl mx-auto px-6 lg:px-8 pt-32 pb-20 text-center">
          <div className="flex items-center justify-center gap-2 text-accent-400 text-sm font-semibold mb-6">
            <Link to="/" className="text-surface-500 hover:text-white transition">Ana Səhifə</Link>
            <svg className="w-3.5 h-3.5 text-surface-600" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
            <span className="text-white/70">Haqqımızda</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6">
            Biz <span className="text-gradient">Tixy</span>-yik
          </h1>
          <p className="text-lg text-surface-400 max-w-2xl mx-auto leading-relaxed font-light">
            Azərbaycanda tədbirlərə bilet almağın ən rahat və təhlükəsiz yolunu yaradırıq.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-20 md:py-28">
          <div className="space-y-16">
            {/* Mission */}
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
              <div className="md:w-1/3 flex-shrink-0">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent-500/10 to-accent-600/10 border border-accent-500/10 flex items-center justify-center mb-4">
                  <svg className="w-7 h-7 text-accent-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 00-2.58 5.841m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 01-2.448-2.448 14.9 14.9 0 01.06-.312m-2.24 2.39a4.493 4.493 0 00-1.757 4.306 4.493 4.493 0 004.306-1.758M16.5 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-surface-900">Missiyamız</h2>
              </div>
              <div className="md:w-2/3">
                <p className="text-surface-600 leading-relaxed text-lg">
                  Tixy.az — konsertlər, festivallar, teatr tamaşaları və digər tədbirlər üçün onlayn bilet satış platformasıdır.
                  Biz insanları sevdikləri tədbirlərlə bir araya gətirməyi missiya edirik. Tixy.az sayəsində bilet almaq sürətli,
                  təhlükəsiz və asandır.
                </p>
              </div>
            </div>

            <div className="border-t border-surface-100" />

            {/* Approach */}
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
              <div className="md:w-1/3 flex-shrink-0">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500/10 to-emerald-600/10 border border-emerald-500/10 flex items-center justify-center mb-4">
                  <svg className="w-7 h-7 text-emerald-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-surface-900">Yanaşmamız</h2>
              </div>
              <div className="md:w-2/3">
                <p className="text-surface-600 leading-relaxed text-lg">
                  Komandamız innovasiyanı və müştəri məmnuniyyətini ön planda saxlayır. Biz daim xidmətimizi inkişaf etdirərək
                  istifadəçilərimizə ən yaxşı təcrübəni təqdim etməyə çalışırıq. Hər bir tədbir sevəri üçün
                  rahat, sürətli və etibarlı bilet alma prosesi təmin edirik.
                </p>
              </div>
            </div>

            <div className="border-t border-surface-100" />

            {/* Values */}
            <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
              <div className="md:w-1/3 flex-shrink-0">
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500/10 to-amber-600/10 border border-amber-500/10 flex items-center justify-center mb-4">
                  <svg className="w-7 h-7 text-amber-500" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-surface-900">Dəyərlərimiz</h2>
              </div>
              <div className="md:w-2/3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { title: 'Etibarlılıq', desc: 'Təhlükəsiz ödəniş və məlumat qorunması' },
                    { title: 'Sadəlik', desc: 'Bir neçə kliklə bilet alma imkanı' },
                    { title: 'Sürət', desc: 'Ani bilet təsdiqləmə sistemi' },
                    { title: 'Dəstək', desc: '24/7 müştəri xidməti' },
                  ].map((item) => (
                    <div key={item.title} className="bg-surface-50 rounded-2xl p-5">
                      <h3 className="font-semibold text-surface-900 mb-1">{item.title}</h3>
                      <p className="text-sm text-surface-500">{item.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 bg-gradient-to-br from-surface-950 to-surface-800 rounded-3xl p-10 md:p-14 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-mesh opacity-15" />
            <div className="relative">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">Sizin məmnuniyyətiniz bizim uğurumuzdur</h3>
              <p className="text-surface-400 mb-8 max-w-lg mx-auto">
                Sualınız və ya təklifiniz varsa, bizimlə əlaqə saxlamaqdan çəkinməyin.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a href="mailto:info@tixy.az" className="inline-flex items-center gap-2 bg-white text-surface-900 font-semibold px-7 py-3.5 rounded-2xl hover:shadow-[0_20px_60px_-10px_rgba(139,92,246,0.4)] transition-all duration-500">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                  </svg>
                  info@tixy.az
                </a>
                <a href="tel:+994556611161" className="inline-flex items-center gap-2 glass text-white font-medium px-7 py-3.5 rounded-2xl hover:bg-white/[0.15] transition-all duration-300">
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                  </svg>
                  +994 55 661 11 61
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AboutPage;
